import { useEffect, useState } from "react";
import PageTitle from "../Helpers/PageTitle";
import Layout from "../Partials/Layout";
import { ErrorToaster } from "../Helpers/toaster/Toaster";
import { Box, CircularProgress } from "@mui/material";
import WebsiteServices from "../../apis/website/WebsiteServices";

export default function Tutorial() {

  // *For Loading
  const [loader, setLoader] = useState(false);

  // *For Tutorial
  const [tutorial, setTutorial] = useState();

  // *For Image baseUrl
  const [baseUrl, setBaseUrl] = useState('');

  // *For Get Web Sections
  const getWebSections = async () => {
    setLoader(true)
    try {
      let params = {
        section: 'tutorial',
      }
      const { data, imageBaseUrl } = await WebsiteServices.getWebSection(params)
      setTutorial(data[0])
      setBaseUrl(imageBaseUrl)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoader(false)
    }
  }

  useEffect(() => {
    // getWebSections()
  }, []);

  return (
    <Layout childrenClasses="pt-0 pb-0">
      <div className="terms-condition-page w-full bg-white pb-[30px]">
        <div className="w-full mb-[30px]">
          <PageTitle
            breadcrumb={[
              { name: "home", path: "/" },
              { name: "Tutorial", path: "tutorial" },
            ]}
            title="Tutorial"
          />
        </div>
        <div className="aboutus-wrapper w-full">
          <div className="container-x mx-auto">
            <div className="w-full min-h-[450px] lg:flex lg:space-x-12 items-center pb-10 lg:pb-0">
              <div className="content flex-1">
                <h1 className="text-[24px] font-bold text-qblack mb-2.5">
                  How to register as a Supplier
                </h1>
              </div>
              <div className="md:w-[570px] w-full h-auto rounded overflow-hidden my-5 lg:my-0">
                <video className="w-full" autoPlay loop controls>
                  <source src={`${process.env.PUBLIC_URL}/assets/videos/supplier.mp4`} type="video/mp4" autoPlay />
                </video>
              </div>
            </div>
          </div>
          <div className="container-x mx-auto">
            <div className="w-full min-h-[450px] lg:flex lg:space-x-12 items-center pb-10 lg:pb-0">
              <div className="md:w-[570px] w-full h-auto rounded overflow-hidden my-5 lg:my-0">
                <video className="w-full" loop controls>
                  <source src={`${process.env.PUBLIC_URL}/assets/videos/manufacturer.mp4`} type="video/mp4" />
                </video>
              </div>
              <div className="content flex-1">
                <h1 className="text-[24px] font-bold text-qblack mb-2.5">
                  How to register as a Manufacturer
                </h1>
              </div>
            </div>
          </div>
          <div className="container-x mx-auto">
            <div className="w-full min-h-[450px] lg:flex lg:space-x-12 items-center pb-10 lg:pb-0">
              <div className="content flex-1">
                <h1 className="text-[24px] font-bold text-qblack mb-2.5">
                  How to register as a Dropshipper
                </h1>
              </div>
              <div className="md:w-[570px] w-full h-auto rounded overflow-hidden my-5 lg:my-0">
                <video className="w-full" loop controls>
                  <source src={`${process.env.PUBLIC_URL}/assets/videos/dropshipper.mp4`} type="video/mp4" />
                </video>
              </div>
            </div>
          </div>
          <div className="container-x mx-auto">
            <div className="w-full min-h-[450px] lg:flex lg:space-x-12 items-center pb-10 lg:pb-0">
              <div className="md:w-[570px] w-full h-auto rounded overflow-hidden my-5 lg:my-0">
                <video className="w-full" loop controls>
                  <source src={`${process.env.PUBLIC_URL}/assets/videos/guest-buyer.mp4`} type="video/mp4" />
                </video>
              </div>
              <div className="content flex-1">
                <h1 className="text-[24px] font-bold text-qblack mb-2.5">
                  How to register as a Guest buyer
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
